module.exports = __webpack_public_path__ + "media/loans/father-son-ac4831ea.jpg";